import React from 'react';
import { useTranslation } from 'react-i18next';
import './ListSelectionDialog.css';

interface ListSelectionDialogProps {
    lists: { id: string; name: string }[];
    selectedListId: string;
    onSelectList: (listId: string) => void;
    onClose: () => void;
}

const ListSelectionDialog: React.FC<ListSelectionDialogProps> = ({ 
    lists, 
    selectedListId, 
    onSelectList, 
    onClose 
}) => {
    const { t } = useTranslation();
    
    return (
        <div className="list-selection-overlay" onClick={(e) => { e.stopPropagation(); onClose(); }}>
            <div className="list-selection-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="list-selection-header">
                    <h3>{t('listSelectionDialog.moveToCollection')}</h3>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>
                <div className="list-selection-content">
                    {!lists || lists.length <= 1 ? (
                        <p>{t('listSelectionDialog.noCollectionsAvailable')}</p>
                    ) : (
                        <ul className="list-selection-items">
                            {lists
                                .filter(list => list.id !== selectedListId)
                                .map(list => (
                                    <li 
                                        key={list.id} 
                                        className="list-selection-item"
                                        onClick={() => {
                                            onSelectList(list.id);
                                            onClose();
                                        }}
                                    >
                                        {list.name}
                                    </li>
                                ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ListSelectionDialog;
